import {
  GridRowId
} from "@mui/x-data-grid";
import { createContext } from "react";

export type DataGridContextType = {
  expandAllDisabled: boolean;
  collapseAllDisabled: boolean;
  headerFilters: boolean;
  autosizeColumns: boolean;
  autosizeTreeDataGroupingColumns: boolean;
  setHeaderFilters: (value: boolean) => void;
  setAutosizeColumns: (value: boolean) => void;
  setAutosizeTreeDataGroupingColumns: (value: boolean) => void;
  onExpandAll: (event: any, rowId: GridRowId) => void;
  onCollapseAll: (event: any, rowId: GridRowId) => void;
  onExpandRow: (event: any, rowId: GridRowId) => void;
  onCollapseRow: (event: any, rowId: GridRowId) => void;
};

export const DataGridContext = createContext<DataGridContextType | null>(null);

